import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=31b467dc&scoped=true"
import script from "./Popups.vue?vue&type=script&lang=ts"
export * from "./Popups.vue?vue&type=script&lang=ts"
import style0 from "./Popups.vue?vue&type=style&index=0&id=31b467dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b467dc",
  null
  
)

export default component.exports